var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneNumberFormat = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M17.25 16.299c0 .359 0 .95-.376.95a10.2 10.2 0 0 1-2.504-.398 10.4 10.4 0 0 1-1.871-.732 10.55 10.55 0 0 1-4.82-5.009 10.4 10.4 0 0 1-.908-3.45c-.07-.724-.042-.91 1.382-.91h1.135a.75.75 0 0 1 .732.582l.283 1.234a1.5 1.5 0 0 1-.402 1.395l-.764.762a1.5 1.5 0 0 1-.486.33 9.65 9.65 0 0 0 4.19 4.23q.045-.053.096-.103l1.096-1.094a1.5 1.5 0 0 1 1.397-.402l1.236.282a.75.75 0 0 1 .584.731V16.3ZM9.424 8.765S9.16 7.65 8.985 7.65h-.832c-.182 0-.483-.024-.456.21.095.826.295 1.62.587 2.368a.6.6 0 0 0 .215-.14l.764-.763a.6.6 0 0 0 .161-.558Zm6.924 6.783v.726c0 .21-1.807-.269-2.636-.596l.959-.957a.6.6 0 0 1 .558-.16s.98.206 1.073.255.05.153.046.732",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneNumberFormat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone-number-format.dea987cd.svg";